"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDiffDay = getDiffDay;
exports.NudgePrompt = exports["default"] = exports.nudgeTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _values = _interopRequireDefault(require("lodash/values"));

var _moment = _interopRequireDefault(require("moment"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Cancel = _interopRequireDefault(require("@material-ui/icons/Cancel"));

var _withStyles = _interopRequireDefault(require("@material-ui/styles/withStyles"));

var _hover = require("../../hooks/hover");

var _nudgeTextTypes;

var CloseIcon = (0, _withStyles["default"])({
  root: {
    fontSize: '1rem'
  }
})(_Cancel["default"]);
var nudgeTypes = {
  reply: 1,
  followup: 2
};
exports.nudgeTypes = nudgeTypes;
var nudgeTextTypes = (_nudgeTextTypes = {}, (0, _defineProperty2["default"])(_nudgeTextTypes, nudgeTypes.reply, 'nudge.reply_interval'), (0, _defineProperty2["default"])(_nudgeTextTypes, nudgeTypes.followup, 'nudge.followup_interval'), _nudgeTextTypes);

var View = function View(_ref) {
  var type = _ref.type,
      emailTime = _ref.emailTime,
      onClick = _ref.onClick;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useHover = (0, _hover.useHover)(),
      hovered = _useHover.hovered,
      targetProps = _useHover.targetProps;

  var diffDay = getDiffDay(emailTime);

  if (diffDay > 0 && (0, _values["default"])(nudgeTypes).includes(type)) {
    return /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({}, targetProps, {
      className: (0, _classnames["default"])('font-bold inline-flex items-center flex-shrink-0', 'self-center mx-1 px-2 rounded', {
        'text-primary bg-transparent': !hovered,
        'text-white bg-primary': hovered
      })
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "py-1 mr-2 text-xs select-none"
    }, t(nudgeTextTypes[type], {
      day: diffDay
    })), /*#__PURE__*/_react["default"].createElement("button", {
      className: (0, _classnames["default"])('inline-flex', {
        'opacity-0': !hovered
      }),
      onClick: onClick
    }, /*#__PURE__*/_react["default"].createElement(CloseIcon, null)));
  } else return null;
};

var _default = View;
exports["default"] = _default;

var NudgePrompt = function NudgePrompt(_ref2) {
  var type = _ref2.type,
      emailTime = _ref2.emailTime,
      className = _ref2.className,
      onClick = _ref2.onClick;

  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  var diffDay = getDiffDay(emailTime);

  if (diffDay > -1 && (0, _values["default"])(nudgeTypes).includes(type)) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex items-center justify-between px-4 py-5 text-sm bg-secondary text-primary', className)
    }, /*#__PURE__*/_react["default"].createElement("span", null, t(nudgeTextTypes[type], {
      postProcess: 'interval',
      count: diffDay
    })), /*#__PURE__*/_react["default"].createElement("button", {
      className: "px-2 py-1 font-bold rounded hover:bg-gray-divider",
      onClick: onClick
    }, t('button.dismiss')));
  } else return null;
};

exports.NudgePrompt = NudgePrompt;

function getDiffDay(emailTime) {
  return (0, _moment["default"])().startOf('d').diff(_moment["default"].unix(emailTime).startOf('d'), 'd');
}
//# sourceMappingURL=index.js.map